/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FreeholdInputs */

const en_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freehold`)
};

const es_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pleno dominio`)
};

const fr_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pleine propriété`)
};

const de_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigentum`)
};

const ja_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全所有権`)
};

const zh_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久产权`)
};

const ar_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تملك حر (Freehold)`)
};

const id_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hak Milik (Freehold)`)
};

const it_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piena Proprietà`)
};

const ru_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фригольд (полная собственность)`)
};

const pt_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propriedade Plena`)
};

const ko_val_freehold = /** @type {(inputs: Val_FreeholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완전 소유권 (Freehold)`)
};

/**
* | output |
* | --- |
* | "Freehold" |
*
* @param {Val_FreeholdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_freehold = /** @type {((inputs?: Val_FreeholdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FreeholdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_freehold(inputs)
	if (locale === "es") return es_val_freehold(inputs)
	if (locale === "fr") return fr_val_freehold(inputs)
	if (locale === "de") return de_val_freehold(inputs)
	if (locale === "ja") return ja_val_freehold(inputs)
	if (locale === "zh") return zh_val_freehold(inputs)
	if (locale === "ar") return ar_val_freehold(inputs)
	if (locale === "id") return id_val_freehold(inputs)
	if (locale === "it") return it_val_freehold(inputs)
	if (locale === "ru") return ru_val_freehold(inputs)
	if (locale === "pt") return pt_val_freehold(inputs)
	return ko_val_freehold(inputs)
});